import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { backendUrl } from '../utils/backendUrl';
import './Login.css';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState('verifying');
    const [message, setMessage] = useState('Verifying your email…');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('This verification link is missing a token.');
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const response = await axios.post(backendUrl('/auth/verify-email'), { token }, { withCredentials: true });
                if (!cancelled) {
                    setStatus('success');
                    setMessage(response.data?.message || 'Email verified. You can sign in to Commray.');
                }
            } catch (err) {
                if (!cancelled) {
                    setStatus('error');
                    setMessage(err.response?.data?.error || 'This verification link is invalid or has expired.');
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [searchParams]);

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>Verify Email</h2>
                <p className="subtitle">{status === 'verifying' ? 'Please wait' : 'Commray'}</p>
                {status === 'error' && <div className="error-message">{message}</div>}
                {status === 'success' && <div className="success-message">{message}</div>}
                {status === 'verifying' && (
                    <>
                        <p>{message}</p>
                        <div className="loading-spinner"></div>
                    </>
                )}
                {status !== 'verifying' && (
                    <div className="signup-link">
                        <p><Link to="/login">Continue to login</Link></p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
